import { status } from "state/school_money/entities/Checkout";

export function getCheckout(state) {
  return state.getIn(["school_money", "checkout"]);
}

/**
 * @returns {string}
 */
export function getCheckoutStatus(state) {
  return getCheckout(state).status;
}

/**
 * @returns {boolean}
 */
export function isCheckoutWindowOpen(state) {
  return getCheckoutStatus(state) !== status.CLOSED;
}

/**
 * @returns {boolean}
 */
export function isCheckoutReadyForPayment(state) {
  switch (getCheckoutStatus(state)) {
    case status.PENDING:
    case status.PROCESSING:
      return true;
    default:
      return false;
  }
}

/**
 * @returns {string}
 */
export function getCheckoutSchoolID(state) {
  return getCheckout(state).schoolID;
}

/**
 * @returns {number} money
 */
export function getCheckoutTotalToPay(state) {
  return getCheckout(state).totalToPay;
}

/**
 * @returns {number}
 */
export function getCheckoutTransactionID(state) {
  return getCheckout(state).transactionID;
}

/**
 * @returns {string}
 */
export function getCheckoutError(state) {
  return getCheckout(state).error;
}

/**
 * @returns {string}
 */
export function getCheckoutErrorCode(state) {
  return getCheckout(state).errorCode;
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/checkout.js